import React from 'react';
import { BsWhatsapp, BsGithub, BsBehance, BsLinkedin } from 'react-icons/bs';
// import { MdOutlineMail } from 'react-icons/md';

const SocialMedia = () => (
    <div className="app__social">
      <div>
        <a href="https://wa.me/918769506494" target="_blank" rel="noreferrer">
          <BsWhatsapp />
        </a>
      </div>
      {/* <div>
      <a href="thisismemukul@gmail.com" target="_blank" rel="noreferrer">
        <MdOutlineMail />
      </a>
    </div> */}
      <div>
        <a href="https://www.github.com/thisismemukul" target="_blank" rel="noreferrer">
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/thisisme-mukulsaini" target="_blank" rel="noreferrer">
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://www.behance.net/thisismemukul" target="_blank" rel="noreferrer">
          <BsBehance />
        </a>
      </div>

    </div>
);

export default SocialMedia;